module.exports = __webpack_public_path__ + "static/media/icon-clock-svg.670ec97e.svg";